<div class="form-subcontainer">
  <div class="form-content">
    <div>
      <form autocomplete="off"  formName="requestDD"
        [formGroup]="formGroup"
        (ngSubmit)="confirm()"
        class="fpx-form-group"
      >
        <section class="account-sec">
          <ng-containter *ngIf="accType == 'CA'">
            <h3 class="fpx-sec-title">{{ "DDREQ.currentheader" | translate }}</h3>
          </ng-containter>
          <ng-containter *ngIf="accType == 'SA'">
            <h3 class="fpx-sec-title">{{ "DDREQ.savingsheader" | translate }}</h3>
          </ng-containter>
          <app-account-list
            [accType]="accType"
            formControlName="accountNumber"
            [disabled]="state.disableMode"
          ></app-account-list>
        </section>

        <section class="request-details-sec">
          <h3 class="fpx-sec-title">{{ "DDREQ.subHeader" | translate }}</h3>
          <div class="details-entry-panel">
            <div class="fpx-field">
              <app-bene-name
                label="{{ 'DDREQ.beneficiaryName' | translate }}"
                formControlName="beneName"
              ></app-bene-name>
            </div>
            <div class="fpx-field">
              <app-bene-id-number
                label="{{ 'DDREQ.beneficiaryIDNo' | translate }}"
                formControlName="beneId"
              ></app-bene-id-number>
            </div>
            <div class="fpx-field">
              <app-issue-date
                [minDate]="today"
                label="{{ 'DDREQ.ddIssueDate' | translate }}"
                formControlName="issueDate"
              ></app-issue-date>
            </div>
            <!-- <div class="fpx-field">
              <app-currency
                label="{{ 'DDREQ.currency' | translate }}"
                formControlName="currency"
              ></app-currency>
            </div> -->
            <div class="fpx-field">
              <app-amount
                label="{{ 'DDREQ.amount' | translate }}"
                formControlName="amount"
                [debitAccountNumber]="state.activeDebitAccountNumber"
                [balanceCheck]="true"
                [errorType]="errorType"
                [disabled]="disableMode"
              ></app-amount>
            </div>
            <!-- <div class="fpx-field">
              <app-exchange-rate
                label="{{ 'DDREQ.exchangeRate' | translate }}"
                formControlName="exchangeRate"
                parentFormcontrolName="currency"
                [changePublisher]="formChangePublisher$"
              ></app-exchange-rate>
            </div> -->
            <!-- <div class="fpx-field">
              <app-state
                label="{{ 'DDREQ.payableAtState' | translate }}"
                formControlName="payableState"
              ></app-state>
            </div> -->
            <!-- <div class="fpx-field">
              <app-payable-city
                label="{{ 'DDREQ.paymentAtCity' | translate }}"
                formControlName="payableCity"
                depenencyControlName="payableState"
                [changePublisher]="formChangePublisher$"
              ></app-payable-city>
            </div> -->
            <div class="fpx-field">
              <app-delivery-options
                label="{{ 'DDREQ.deliveryOption' | translate }}"
                direction="row"
                labelPosition="after"
                formControlName="dlvryOption"
              ></app-delivery-options>
            </div>
            <div class="fpx-field">
              <app-branches
                label="{{ 'DDREQ.deliveryBranch' | translate }}"
                formControlName="dlvryBranch"
                [bankCodeEditValue]="'FIEGEGCXXXX'"
                [changePublisher]="formChangePublisher$"
              ></app-branches>
            </div>
            <div class="fpx-field">
              <app-remarks
                label="{{ 'DDREQ.remarks' | translate }}"
                formControlName="remarks"
              ></app-remarks>
            </div>

            <div class="center-main" [hidden]="requestReference">
              <ng-container *ngIf="!formGroup.disabled; else confirmTemplate">
                <section class="from-button-sec">
                  <button class="btn-link" (click)="reset()">
                    <span>{{ "FORM_ACTIONS.reset" | translate }}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button
                    type="button"
                    (click)="submit()"
                    class="button-common button40 active"
                    [disabled]="formGroup.invalid"
                  >
                    <span>{{ "FORM_ACTIONS.submit" | translate }}</span>
                  </button>
                </section>
              </ng-container>

              <ng-template #confirmTemplate>
                <section class="from-button-sec">
                  <button class="btn-link" (click)="edit()">
                    <span>{{ "FORM_ACTIONS.edit" | translate }}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button
                    type="submit"
                    class="button-common button40 active"
                    [disabled]="formGroup.invalid"
                  >
                    <span>{{ "FORM_ACTIONS.confirm" | translate }} </span>
                  </button>
                </section>
              </ng-template>
            </div>

            <!-- <section class="from-button-sec">
              <button
                class="button-common button40 active"
                [disabled]="formGroup.invalid"
              >
                <span>{{ "FORM_ACTIONS.submit" | translate }}</span>
              </button>
            </section> -->
          </div>
        </section>
      </form>
    </div>
  </div>
</div>
